export default __webpack_public_path__ + "static/media/keycard_button_step.426675d5.png";